'use strict';
import { addEvent } from '../addEvent/addEvent';

export const mainPageBaner = class {
  mainContainer = false;
  ulContainer = false;

  contentTxtContainer = false;
  contentBgContainer = false;
  inProgress = false;
  curentElement = 0;
  elements = [];

  curentTxtElement = null;
  curentImgElement = null;

  controlContainer = null;

  //class animacji
  mainContainerAnimationClass = 'main-page-baner--animation';
  inAnimationClass = 'main-page-baner__in-animation';
  outAnimationClass = 'main-page-baner__out-animation';

  //class dla tworzonych elementow
  showContainer_contentContainer = 'show-container__contentContainer';
  contentContainerClass = 'show-container__element';
  bgContainerClass = 'main-page-baner__bgContainer';
  bgFirstSlideClass = 'main-page-baner__image--first-slide';

  slideControlContainerClass = 'main-page-baner__slides-control';
  slideControlContainerShowClass = 'main-page-baner__slides-control--show';
  slideControlChangeSlideButtonClass = 'slides-control__change-slide';
  slideControlChangeSlidePrevButtonClass = 'slides-control__change-slide--prev';
  slideControlChangeSlideNextButtonClass = 'slides-control__change-slide--next';

  //class do zczytywania elementow
  banerUlClass = 'main-page-baner__list';

  autoChange = true;
  autoChangeTime = 8000;
  autoChangeTimer = false;

  letterInAnimationTime = 850;
  letterOutAnimationTime = 850;
  letterDeleyAnimationTime = 100;

  touchstartx = undefined;
  touchmovex = undefined;
  movex = undefined;
  longTouch = undefined;

  constructor(mainContainer) {
    if (!mainContainer) {
      return false;
    }
    this.mainContainer = mainContainer;

    return this;
  }

  init = () => {
    this.ulContainer = this.mainContainer.getElementsByClassName(
      this.banerUlClass
    )[0];

    const directLiElements = Array.from(this.ulContainer.children).filter(
      el => el.tagName === 'LI'
    );

    directLiElements.forEach(li => {
      const item = {
        txtContainer: null,
        txtRowOneLetters: 0,
        txtRowTwoLetters: 0,
        txtRowThereWards: 0,
        imageContainer: null,
        time: null,
        animationInTime: 0,
        animationOutTime: 0,
      };

      item.txtContainer = li
        .querySelector('.main-page-baner__content')
        .cloneNode(true);
      item.txtContainer.querySelector('.main-page-baner__image').remove();
      item.imageContainer = li
        .querySelector('.main-page-baner__image')
        .cloneNode(true);
      const time = li.getAttribute('data-time');
      item.time = time ? time : this.autoChangeTime;

      const title = item.txtContainer.querySelector('.title');
      const spanOne = title.querySelector('.row__one');
      const spanTwo = title.querySelector('.row__two');
      const spanThree = title.querySelector('.row__three');

      // Obudowanie liter w spanOne
      const totalLettersOne = spanOne.textContent.trim().length;
      item.txtRowOneLetters = totalLettersOne;
      spanOne.innerHTML = this._wrapLettersInSpan(
        spanOne.textContent.trim(),
        this.letterInAnimationTime,
        this.letterDeleyAnimationTime,
        0
      );

      // Obudowanie liter w spanTwo
      const totalLettersTwo = spanTwo.textContent.trim().length;
      item.txtRowTwoLetters = totalLettersTwo;
      spanTwo.innerHTML = this._wrapLettersInSpan(
        spanTwo.textContent.trim(),
        this.letterInAnimationTime,
        this.letterDeleyAnimationTime,
        totalLettersOne
      );

      // Obudowanie wyrazow w spanTwo
      const totalWordsThree = spanTwo.textContent.trim().split(/\s+/).length;
      spanThree.style.setProperty(
        '--animation-duration',
        `${this.letterInAnimationTime}ms`
      );
      spanThree.style.setProperty(
        '--animation-delay-in',
        `${
          this.letterDeleyAnimationTime * (totalLettersOne + totalLettersTwo)
        }ms`
      );
      spanThree.style.setProperty(
        '--animation-delay-before-out',
        `${
          this.letterDeleyAnimationTime * (totalLettersOne + totalWordsThree) +
          this.letterOutAnimationTime
        }ms`
      );

      spanThree.innerHTML = this._wrapWordsInSpan(
        spanThree.textContent.trim(),
        this.letterInAnimationTime,
        this.letterDeleyAnimationTime,
        totalLettersOne + totalLettersTwo
      );

      item.animationInTime =
        this.letterDeleyAnimationTime *
          (totalLettersOne + totalLettersTwo + totalWordsThree) +
        this.letterInAnimationTime;

      item.animationOutTime = item.animationInTime;

      // Dodanie elementu do tablicy elements
      this.elements.push(item);
    });

    this.ulContainer.remove();

    //pojemnik txt
    this.contentTxtContainer = document.createElement('div');
    this.contentTxtContainer.classList.add(this.showContainer_contentContainer);
    this.mainContainer.appendChild(this.contentTxtContainer);

    //pojemnik tla
    this.contentBgContainer = document.createElement('div');
    this.contentBgContainer.classList.add(this.bgContainerClass);
    this.mainContainer.appendChild(this.contentBgContainer);

    this._createSlidesControl();
  };

  start = () => {
    const { inAnimationClass, _setTimer } = this;

    this.curentTxtElement = document.createElement('div');
    this.curentTxtElement.classList.add(this.contentContainerClass);
    this.curentTxtElement.appendChild(
      this.elements[this.curentElement].txtContainer.cloneNode(true)
    );
    this.contentTxtContainer.appendChild(this.curentTxtElement);

    this.curentImgElement =
      this.elements[this.curentElement].imageContainer.cloneNode(true);
    this.curentImgElement.classList.add(this.bgFirstSlideClass);
    this.contentBgContainer.appendChild(this.curentImgElement);

    setTimeout(() => {
      this.curentTxtElement.classList.add(inAnimationClass);
      this.curentImgElement.classList.add(inAnimationClass);
      this.controlContainer.classList.add(this.slideControlContainerShowClass);
    }, 100);

    if (this.elements.length > 1) {
      this._touchInit();
      setTimeout(() => {
        _setTimer();
      }, this.elements[this.curentElement].animationOutTime);
    }
  };

  _changeSlide = nextIndex => {
    const {
      curentElement,
      inAnimationClass,
      outAnimationClass,
      bgFirstSlideClass,
      elements,
      _setTimer,
    } = this;

    if (this.inProgress == true) _setTimer();

    const nextElementInfo = elements[nextIndex];
    if (!nextElementInfo) return;

    this.inProgress = true;

    const currentElementInfo = elements[curentElement];

    let nextElementTxt = document.createElement('div');
    nextElementTxt.classList.add(this.contentContainerClass);
    nextElementTxt.appendChild(nextElementInfo.txtContainer.cloneNode(true));
    this.contentTxtContainer.appendChild(nextElementTxt);

    this.curentTxtElement.classList.remove(inAnimationClass);
    this.curentTxtElement.classList.add(outAnimationClass);

    let nextElementImg = nextElementInfo.imageContainer.cloneNode(true);
    this.contentBgContainer.appendChild(nextElementImg);

    setTimeout(
      () => {
        this.curentImgElement.classList.remove(inAnimationClass);
        this.curentImgElement.classList.remove(bgFirstSlideClass);
        this.curentImgElement.classList.add(outAnimationClass);

        nextElementTxt.classList.add(inAnimationClass);
        nextElementImg.classList.add(inAnimationClass);
      },
      this.letterOutAnimationTime + this.letterDeleyAnimationTime * 2
    );

    setTimeout(() => {
      this.curentTxtElement.remove();
      this.curentImgElement.remove();
      this.curentTxtElement = nextElementTxt;
      this.curentImgElement = nextElementImg;
      this.curentElement = nextIndex;
      this.inProgress = false;
      _setTimer();
    }, currentElementInfo.animationOutTime);
  };

  _setTimer = () => {
    const { autoChange, curentElement, elements, _changeSlide } = this;
    if (!autoChange || elements.length < 2) return;
    clearTimeout(this.autoChangeTimer);

    const time = elements[curentElement].time;
    const nextIndex =
      curentElement + 1 >= elements.length ? 0 : curentElement + 1;

    this.autoChangeTimer = setTimeout(() => {
      _changeSlide(nextIndex);
    }, time);
  };

  _createSlidesControl = () => {
    const {
      mainContainer,
      contentTxtContainer,
      slideControlContainerClass,
      slideControlContainerShowClass,
      slideControlChangeSlideButtonClass,
      slideControlChangeSlidePrevButtonClass,
      slideControlChangeSlideNextButtonClass,
      _slidesPrevNextControlClick,
    } = this;

    if (this.elements.length < 2) {
      return;
    }

    const svg =
      '<svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="48" ></circle></svg>';

    this.controlContainer = document.createElement('div');
    this.controlContainer.classList.add(slideControlContainerClass);

    const prevSlideButton = document.createElement('div');
    prevSlideButton.innerHTML = svg + svg;
    prevSlideButton.classList.add(slideControlChangeSlideButtonClass);
    prevSlideButton.classList.add(slideControlChangeSlidePrevButtonClass);
    _slidesPrevNextControlClick(prevSlideButton, -1);

    this.controlContainer.insertBefore(
      prevSlideButton,
      this.controlContainer.firstChild
    );

    let nextSlideButton = document.createElement('div');
    nextSlideButton.innerHTML = svg + svg;
    nextSlideButton.classList.add(slideControlChangeSlideButtonClass);
    nextSlideButton.classList.add(slideControlChangeSlideNextButtonClass);
    _slidesPrevNextControlClick(nextSlideButton, 1);
    this.controlContainer.appendChild(nextSlideButton);

    contentTxtContainer.appendChild(this.controlContainer);
  };

  _slidesPrevNextControlClick = (clikcElement, step) => {
    addEvent(clikcElement, 'click', e => {
      const { elements, curentElement, _changeSlide } = this;

      if (this.inProgress == true) {
        return;
      }

      clearTimeout(this.autoChangeTimer);

      let nextIndex = curentElement + step;

      if (nextIndex < 0) {
        nextIndex = elements.length - 1;
      }
      if (nextIndex >= elements.length) {
        nextIndex = 0;
      }

      _changeSlide(nextIndex);
    });
  };

  _wrapLettersInSpan = (
    text,
    animationInTime,
    animationInTimeDelay,
    startIndex
  ) => {
    return Array.from(text)
      .map((letter, index) => {
        const span = document.createElement('span');
        span.textContent = letter;
        span.style.setProperty('--animation-duration', `${animationInTime}ms`);
        span.style.setProperty(
          '--animation-delay',
          `${animationInTimeDelay * (index + startIndex)}ms`
        );
        return span.outerHTML;
      })
      .join('');
  };

  _wrapWordsInSpan = (
    text,
    animationInTime,
    animationInTimeDelay,
    startIndex
  ) => {
    return text
      .split(/\s+/) // Rozdzielanie tekstu na słowa (wszystkie białe znaki jako separator)
      .map((word, index) => {
        const span = document.createElement('span');
        span.textContent = word; // Ustawianie treści jako całe słowo
        span.style.setProperty('--animation-duration', `${animationInTime}ms`);
        span.style.setProperty(
          '--animation-delay',
          `${animationInTimeDelay * (index + startIndex)}ms`
        );
        span.style.setProperty(
          '--animation-out-delay',
          `${animationInTimeDelay * index}ms`
        );
        return span.outerHTML; // Zwracanie HTML-a elementu span
      })
      .join(' '); // Łączenie słów z powrotem, dodając spację między nimi
  };

  _touchInit = () => {
    const { mainContainer, _touchChangeSlide } = this;

    mainContainer.addEventListener(
      'touchstart',
      e => {
        this.touchstartx = e.changedTouches[0].pageX;

        this.longTouch = false;
        setTimeout(() => {
          this.longTouch = true;
        }, 50);
      },
      { passive: true }
    );

    mainContainer.addEventListener(
      'touchmove',
      e => {
        this.touchmovex = e.changedTouches[0].pageX;
      },
      { passive: true }
    );

    mainContainer.addEventListener(
      'touchend',
      e => {
        this.movex = this.touchstartx - this.touchmovex;

        if (this.longTouch && this.movex > 50) {
          _touchChangeSlide(1);
        }

        if (this.longTouch && this.movex < -50) {
          _touchChangeSlide(-1);
        }
      },
      { passive: true }
    );
  };

  _touchChangeSlide = step => {
    const { elements, _changeSlide } = this;

    if (this.inProgress) {
      return;
    }
    if (this.inProgress == true) _setTimer();

    let elementToShow = this.curentElement + step;
    if (elementToShow < 0) {
      elementToShow = elements.length - 1;
    }
    if (elementToShow >= elements.length) {
      elementToShow = 0;
    }

    _changeSlide(elementToShow);
  };
};
